import {
  Box,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { signInPage } from '../../../copy';
import VerifyForm from '../verify-form';
import SigninFormWithEmail from './signin-form-email';
import SigninFormWithMobile from './signin-form-mobile';
import SigninFormWithUserId from './signin-form-userId';

const { signin, userId, mobileNumber, emailId } = signInPage;

const SignInForm = ({
  switchToSignUp,
  switchToForgotPassword,
  switchToOnboarding,
}) => {
  const [signInState, setSigninState] = useState('signinUserId');
  const [userName, setUserName] = useState('');

  function signInStateChange(signInStateValue, userNameValue) {
    setSigninState(signInStateValue);
    setUserName(userNameValue);
  }

  return (
    <Stack px={12}>
      {signInState === 'signinUserId' ? (
        <>
          <Stack>
            <h1>{signin}</h1>
          </Stack>
          <Box>
            <Stack spacing={4} mt="3">
              <Tabs isFitted>
                <TabList lineHeight={4}>
                  <Tab
                    _selected={{
                      color: 'brand.red',
                      borderBottomColor: 'brand.red',
                      boxShadow: 'none',
                    }}
                  >
                    {userId}
                  </Tab>
                  <Tab
                    _selected={{
                      color: 'brand.red',
                      borderBottomColor: 'brand.red',
                      boxShadow: 'none',
                    }}
                  >
                    <Text>{mobileNumber}</Text>
                  </Tab>
                  <Tab
                    _selected={{
                      color: 'brand.red',
                      borderBottomColor: 'brand.red',
                      boxShadow: 'none',
                    }}
                  >
                    {emailId}
                  </Tab>
                </TabList>
                <TabPanels>
                  <TabPanel alignItems="start">
                    <SigninFormWithUserId
                      switchToSignUp={switchToSignUp}
                      switchToForgotPassword={switchToForgotPassword}
                      switchToOnboarding={switchToOnboarding}
                      switchToVerifyForm={signInStateChange}
                    />
                  </TabPanel>
                  <TabPanel>
                    <SigninFormWithMobile
                      switchToSignUp={switchToSignUp}
                      switchToForgotPassword={switchToForgotPassword}
                      switchToOnboarding={switchToOnboarding}
                    />
                  </TabPanel>
                  <TabPanel>
                    <SigninFormWithEmail
                      switchToSignUp={switchToSignUp}
                      switchToForgotPassword={switchToForgotPassword}
                      switchToOnboarding={switchToOnboarding}
                    />
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Stack>
          </Box>
        </>
      ) : signInState === 'verification' ? (
        <VerifyForm
          username={userName}
          switchToSignIn={() => setSigninState('signinUserId')}
          verifyFromSignIn="true"
        />
      ) : null}
    </Stack>
  );
};

export default SignInForm;
